export default __webpack_public_path__ + "static/media/green-logo-covid-status.2fe14c0a.svg";